<template lang="pug">
div
	div.block
		arrowReturn.button3(v-show="hasprev" @arrow-return="prevStep")
		transition(type="slide")
			div.cube(v-for="d in this.currentStep.data" key="d" v-if="d == slide")
				div.imagescen
					imageLoader(:imagesrc="d.image")
				div.title
					initialText.textcen(:text="d.initialText")
		div.button2
			arrowNext(v-show="hasnext" @arrow-next="nextStep")
		div.ovalbox
			div.ovcontainer(v-for="l in this.currentStep.data")
				div.ov(key="l" v-if="l != slide")
				div.ov.ovhl(key="l" v-else)
	div(v-if="this.step < (this.total -1)")
		el-button.ButtonNext(type="info") Ok, ¡Entendido!
	div(v-else @click="reset")
		buttonNext2.button()
</template>

<script>

import { mapGetters } from 'vuex';
import arrowReturn from '@/components/paging/arrow-return'
import arrowNext from '@/components/paging/arrow-next'
import buttonNext2 from '@/components/button-next/button-next2'
import initialText from '@/components/initial-text/initial-text'
import imageLoader from "@/components/image-loader/image-loader";

export default {
	name: 'Paging',
	components:{
		arrowReturn,
		buttonNext2,
		arrowNext,
		initialText,
		imageLoader
	},
	computed: {
    	...mapGetters(['currentStep']),
    	slide(){
    		return this.currentStep.data[this.step];
    	},
    	total(){
    		return this.currentStep.data.length;
    	},
    	hasnext(){
    		return this.step < (this.total-1);
    	},
    	hasprev(){
    		return this.step > 0;
    	},
    	getImage() {
      		return this.slide.image;
		},
		getText() {
			return this.slide.initialText;
		}
  	},
	data(){
		return {
			step: 0,
			buttonshow: false,
			img: null,
			text: null
		}
	},
	beforemount:function(){
		this.step = 0;
	},
	methods:{
		reset(){
			this.step = this.step -this.step;
		},
		nextStep(event){
			console.debug("NEXT %d %d", this.step, this.total);
			if(this.step < (this.total -1)){
				this.step++;
				this.buttonshow = false;
			}else{
				this.buttonshow = true;
			}
		},
		prevStep(event){
			console.debug("PREV %d", this.step);
			if(this.step > 0){
				this.step--;
			}
		}
	}
}
</script>

<style scoped>
@import 'paging.scss';
</style>